module.exports = __webpack_public_path__ + "img/page1-1.ef948335.png";